<template>
<div class="check-box-container"  @click="toggleCheck()" :style="{width:width,height:height}">
        <div class="checkbox-icon">
              <!-- 三种状态 选中  未选  禁用 -->
              <svg class="icon-svg selected" :style="{width:width,height:height}" aria-hidden="true" key="select" v-if="checked&&!disabled">
                <use xlink:href="#icon-universal_choose"></use>
              </svg>
              <svg class="icon-svg" :style="{width:width,height:height}" aria-hidden="true" key="unselected" v-if="!checked&&!disabled">
                <use xlink:href="#icon-universal_unchoose"></use>
              </svg>
              <svg class="icon-svg disabled" :style="{width:width,height:height}" aria-hidden="true" key="unselected" v-if="disabled&&!defaultSelect">
                <use xlink:href="#icon-universal_unchoose"></use>
              </svg>
              <svg class="icon-svg disabled" :style="{width:width,height:height}" aria-hidden="true" key="defaultSelected" v-if="disabled&&defaultSelect">
                <use xlink:href="#icon-universal_choose"></use>
              </svg>
            </div>
        <slot></slot>
</div>
</template>
<script>
/**
 * 全局统一弹窗
 */
export default {
  name: 'CommonCkeckBox',
  model: {
    prop: 'checked',
    event: 'changeCheck'
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    }, // 选中状态
    disabled: {
      type: Boolean,
      default: false,
    }, // 是否禁用
    defaultSelect: {
      type: Boolean,
      default: false,
    }, // 是否禁用
    width: {
      type: String,
      default: '16px',
    }, // 按钮默认宽度
    height: {
      type: String,
      default: '16px',
    }, // 按钮默认高度
  },
  created() {
    // console.log('disabled', this.disabled)
  },
  data() {
    return {
    }
  },
  methods: {
    /**
     * 切换选中回传
     */
    toggleCheck() {
      if (this.disabled) return
      this.$emit('changeCheck', !this.checked)
      this.$emit('toggleCheck')
    }
  },
  watch: {
    checked: {
      handler(newValue, oldValue) {
      // 开放状态变更事件
        this.$emit('onChange',newValue)
      },
      deep: true
    }
  },
}
</script>
<style lang="scss"  scoped>
.check-box-container{
    display: flex;
    .checkbox-icon{
      display: flex;
        svg{
          transform: translateZ(0);
          will-change: auto;
          color: #999;
        }
        .disabled{
          color:#f5f5f5;
        }
        .selected {
          color: $themeSynMain;
          background: #fff;
          border-radius: 50%;
        }
    }
}
</style>
